import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function AllChinaBuyVs() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />
      <div className="pt-20 pb-4 bg-white border-b border-stone-100">
        <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
          <nav className="flex items-center gap-2 text-sm text-stone-500">
            <Link to="/" className="hover:text-stone-900 transition-colors cursor-pointer">{t('breadcrumb_home')}</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-stone-900 font-medium">AllChinaBuy vs Competitors</span>
          </nav>
        </div>
      </div>
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12 py-8 md:py-12">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl border border-stone-200 p-6 md:p-10 shadow-sm">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-stone-100 rounded-full text-stone-600 mb-4">9 min read</span>
            <h1 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4">AllChinaBuy vs Superbuy vs CSSBuy vs Sugargoo: Complete Comparison</h1>
            <div className="flex items-center gap-4 text-sm text-stone-500 mb-6">
              <span>{t('article_last_updated')}: August 25, 2026</span>
              <span>{t('article_author')}: AllChinaBuy Research Team</span>
            </div>

            <p className="text-stone-600 leading-relaxed mb-4">
              Choosing the right shopping agent can significantly impact your experience and costs. This comparison breaks down how <strong>AllChinaBuy</strong> stacks against major competitors.
            </p>

            <h2 className="text-xl font-bold text-stone-900 mt-8 mb-3">Comparison Overview</h2>
            <div className="overflow-x-auto mb-4">
              <table className="w-full text-sm border border-stone-200 rounded-xl overflow-hidden">
                <thead><tr className="bg-stone-100"><th className="px-3 py-2 text-left font-semibold">Feature</th><th className="px-3 py-2 text-center">AllChinaBuy</th><th className="px-3 py-2 text-center">Superbuy</th><th className="px-3 py-2 text-center">CSSBuy</th><th className="px-3 py-2 text-center">Sugargoo</th></tr></thead>
                <tbody className="divide-y divide-stone-100">
                  <tr><td className="px-3 py-2 font-medium text-stone-700">Spreadsheet</td><td className="px-3 py-2 text-center text-emerald-600">Excellent</td><td className="px-3 py-2 text-center text-stone-500">Limited</td><td className="px-3 py-2 text-center text-stone-500">Basic</td><td className="px-3 py-2 text-center text-stone-500">Moderate</td></tr>
                  <tr><td className="px-3 py-2 font-medium text-stone-700">QC Photos</td><td className="px-3 py-2 text-center text-emerald-600">Yes</td><td className="px-3 py-2 text-center text-emerald-600">Yes</td><td className="px-3 py-2 text-center text-emerald-600">Yes</td><td className="px-3 py-2 text-center text-emerald-600">Yes</td></tr>
                  <tr><td className="px-3 py-2 font-medium text-stone-700">Interface</td><td className="px-3 py-2 text-center">Clean</td><td className="px-3 py-2 text-center">Feature-rich</td><td className="px-3 py-2 text-center">Functional</td><td className="px-3 py-2 text-center">Modern</td></tr>
                  <tr><td className="px-3 py-2 font-medium text-stone-700">Fees</td><td className="px-3 py-2 text-center">Competitive</td><td className="px-3 py-2 text-center">Standard</td><td className="px-3 py-2 text-center">Low</td><td className="px-3 py-2 text-center">Standard</td></tr>
                </tbody>
              </table>
            </div>

            <h2 className="text-xl font-bold text-stone-900 mt-8 mb-3">Which Agent Is Right for You?</h2>
            <p className="text-stone-600 leading-relaxed mb-4">
              Choose <strong>AllChinaBuy</strong> if you value organized spreadsheet resources and straightforward pricing. For advanced features, Superbuy may suit better. Budget-conscious shoppers might prefer CSSBuy's lower fees, while Sugargoo offers a modern interface experience.
            </p>

            <div className="mt-8 bg-stone-900 rounded-xl p-6 text-center">
              <p className="text-white mb-4">Start with AllChinaBuy Spreadsheet</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-2.5 bg-white text-stone-900 rounded-lg text-sm font-medium hover:bg-stone-100 transition-colors cursor-pointer">
                AllChinaBuy Spreadsheet <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}